import axios from "axios";

export function getClassStatusList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassStatus/getlist", config);
}

export function postClassStatus(data) {
  return axios.post(process.env.VUE_APP_API_URL + "ClassStatus/add", data);
}

export function updateClassStatus(data) {
  return axios.put(process.env.VUE_APP_API_URL + "ClassStatus/update", data);
}

export function deleteClassStatus(classStatusId) {
  const config = {
    params: {
      classStatusId: classStatusId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "ClassStatus/deleted",
    config
  );
}

export function getClassStatusMultiByClassId(data) {
  const config = {
    params: data,
  };
  return axios.get(
    process.env.VUE_APP_API_URL + "ClassStatusMulti/index",
    config
  );
}

export function postClassStatusMulti(data) {
  return axios.post(process.env.VUE_APP_API_URL + "ClassStatusMulti/add", data);
}

export function updateClassStatusMulti(data) {
  return axios.put(
    process.env.VUE_APP_API_URL + "ClassStatusMulti/update",
    data
  );
}

export function deleteClassStatusMulti(classStatusMultiId) {
  const config = {
    params: {
      classStatusMultiId: classStatusMultiId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "ClassStatusMulti/deleted",
    config
  );
}
